import {
  EXT_PING,
  EXT_AUTHENTICATION_SET,
  EXT_AUTHENTICATION_GET,
} from '@dinosave/core/messages';
import {
  getApplicationStore,
} from '@dinosave/core/stores';
import type {
  Message,
  UserEntity,
} from '@dinosave/core/types';

const EXTENSION_ID = import.meta.env.PUBLIC_ENV__EXTENSION_ID;

const setAuthentication = async (
  user: UserEntity | null,
  authentication: string | null,
) => {
  try {
    if (!chrome.runtime) return null;

    const message: Message = {
      type: EXT_AUTHENTICATION_SET,
      payload: {
        user,
        authentication,
      },
    };

    await chrome.runtime.sendMessage(EXTENSION_ID, message);

    return null;
  } catch {
    console.warn('Dinosave extension is not installed!');
  }
};

const getAuthentication = async () => {
  const {
    storage,
  } = getApplicationStore().getState();

  if (
    typeof window === 'undefined' ||
    typeof chrome === 'undefined'
  ) return;

  try {
    if (!chrome.runtime) return null;

    const message: Message = {
      type: EXT_AUTHENTICATION_GET,
    };

    const authentication = await chrome.runtime.sendMessage(EXTENSION_ID, message);

    const isAuthenticated = Object.values(authentication).length;
    if (!isAuthenticated) return;

    return storage.set(authentication);
  } catch {
    console.warn('Dinosave extension is not installed!');
  }
};


const isInstalled = async () => {
  try {
    const message: Message = {
      type: EXT_PING,
    };

    if (!chrome.runtime) return false;

    return chrome.runtime.sendMessage(
      EXTENSION_ID,
      message,
    );
  } catch {
    return false;
  }
};

const extension = {
  isInstalled,
  setAuthentication,
  getAuthentication,
};

export default extension;
